import { render, staticRenderFns } from "./pay-order.vue?vue&type=template&id=afa52b4e&scoped=true&"
import script from "./pay-order.vue?vue&type=script&lang=js&"
export * from "./pay-order.vue?vue&type=script&lang=js&"
import style0 from "./pay-order.vue?vue&type=style&index=0&lang=postcss&"
import style1 from "./pay-order.vue?vue&type=style&index=1&id=afa52b4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa52b4e",
  null
  
)

export default component.exports